import { useFeatureFlag as useConfigCatFeatureFlag } from 'configcat-react';

import { FEATURE_FLAG_DEFAULTS, FeatureFlag } from '@/constants/feature-flags.ts';

import { useConfigCatUser } from '@/hooks/use-config-cat-user.ts';

export const useFeatureFlag = (flag: FeatureFlag): { value: boolean; loading: boolean } => {
    const user = useConfigCatUser();
    const defaultValue = FEATURE_FLAG_DEFAULTS[flag];

    return useConfigCatFeatureFlag(flag, defaultValue, user);
};
